<template>
  <div class="md-layout">
    <md-dialog :md-active.sync="showNewBookingDialog" id="new-booking-dialog">
      <md-dialog-title>Add a new Booking</md-dialog-title>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(createBooking)">
          <div class="md-layout">
            <div class="md-layout-item md-size-50">
              <h6>Lead Booker</h6>
              <customer-dropdown v-model="booking.user_id" />

              <h6>Currency</h6>
              <md-radio v-model="booking.currency" value="gbp">GBP</md-radio>
              <md-radio v-model="booking.currency" value="eur">EUR</md-radio>
              <md-radio v-model="booking.currency" value="usd">USD</md-radio>
            </div>

            <div class="md-layout-item md-size-50">
              <h6>Adventure</h6>
              <md-field>
                <label for="tour">Adventure</label>
                <md-select v-model="selectedTour" name="tour" id="tour">
                  <md-option
                    v-for="(tour, index) in tours"
                    :key="tour.id"
                    :value="index"
                  >
                    {{ tour.title }}
                  </md-option>
                </md-select>
              </md-field>

              <h6>Departure</h6>
              <md-field>
                <label v-if="selectedTour == -1">Please Select a Tour</label>
                <template v-else>
                  <label v-if="!tours[selectedTour].departures.length"
                    >No Departures Available</label
                  >
                  <template v-else>
                    <label>Departure</label>
                    <md-select
                      v-if="tours[selectedTour].departures"
                      v-model="booking.departure_id"
                      name="departure"
                      id="departure"
                    >
                      <md-option
                        v-for="departure in tours[selectedTour].departures"
                        :key="departure.id"
                        :value="departure.id"
                      >
                        <!-- <md-option v-for="departure in selectedTour.departures" :key="departure.id" :value="departure.id"> -->
                        {{ departure.start_date }}
                      </md-option>
                    </md-select>
                  </template>
                </template>
              </md-field>
            </div>
          </div>

          <md-dialog-actions>
            <md-button class="md-primary md-dense" @click="cancel"
              >Cancel</md-button
            >
            <md-button type="submit" class="md-primary md-dense"
              >Create</md-button
            >
          </md-dialog-actions>
        </form>
      </ValidationObserver>
    </md-dialog>
  </div>
</template>

<script>
import bookingApi from "@/services/api/booking";
import customerApi from "@/services/api/customer";
import tourApi from "@/services/api/tour";
import CustomerDropdown from "@/components/Handi/Users/CustomerDropdown.vue";

export default {
  name: "BookingCreateDialog",

  props: ["showNewBookingDialog"],

  data() {
    return {
      booking: {
        currency: "gbp",
        user_id: null,
        departure_id: null
      },
      selectedTour: -1,
      selectedCustomer: null,
      // customers: [],
      tours: []
    };
  },

  components: {
    CustomerDropdown
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    createBooking() {
      bookingApi.createBooking(this.booking).then(response => {
        this.$emit("new-booking", response.data);
      });
    }
  },

  watch: {},

  mounted() {
    customerApi.getCustomers().then(response => {
      this.customers = response.data;
    });

    tourApi.getTours().then(response => {
      this.tours = response.data.tours;
    });
  }
};
</script>
<style lang="scss" scoped>
.md-dialog .md-dialog-container {
  max-width: 768px;
  min-width: 768px;
  width: 768px;
}
</style>
